export const NODATA_MESSAGE = 'No Results Found. Please refine your search.';
